import { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';

import webdesign from "../../images/services/web_design.png"
import appdevelopment from "../../images/services/app_development.png"

const Services = () => {
    useEffect(()=>{

        const scroll = ScrollReveal({
            origin: "top",
            distance: "5rem",
            duration: 2000,
            reset: true
        })

        scroll.reveal(".title_info",{delay: 200})
        scroll.reveal(".service-item",{ delay: 600, interval: 500})
    },[])
    return (
        <section id='services'>
            <div className='service container'>
                <div className='service-top'>
                    <h1 className='section-title'>
                        Serv<span>i</span>ces
                    </h1>
                    <p className="title_info">
                        I design and code simple yet beautiful things, and there
                        is much love to what i do.
                    </p>
                </div>
                <div className='service-bottom'>
                    <div className='service-item'>
                        <div className='icon'>
                            <img
                                src={webdesign}
                                alt='web-design-icon'
                            />
                        </div>
                        <h2>Web Design</h2>
                        <p>
                            I value simple content structure, clean design
                            pattens in UI, Web and Mobile Apps which are User
                            focused and lastly but not the least thoughtful
                            interactions
                        </p>
                    </div>

                    <div className='service-item'>
                        <div className='icon'>
                            <img
                                src={appdevelopment}
                                alt='frontend-development-icon'
                            />
                        </div>
                        <h2>Front-End Development</h2>
                        <p>
                            I enjoy to code things from scratch and always
                            wanting to bring ideas to life through web development
                            with two primary goals: 1st, its needs to work
                            across all devices, 2nd it s needs to be fast as
                            possible.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;
